import React from "react";
import { ConfigProvider, Tabs, theme } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "../../styles/Custom/Dashboard/Users.module.css";
import useIsMobile from "../../hooks/useIsMobile";

const { useToken } = theme;

const AccountTabs = () => {
  const navigate = useNavigate();
  const router = useLocation();
  const isMobile = useIsMobile();
  const { token } = useToken();

  const onChange = (key) => {
    navigate(`/accounts/${key}`, { replace: true });
  };

  const items = [
    {
      key: "details",
      label: isMobile ? "Details" : "My details",
    },
    {
      key: "password",
      label: isMobile ? "Password" : "Change Password",
    },
    {
      key: "experience",
      label: "Experience",
    },
  ];

  const activeKey =
    items.find((item) => router.pathname.includes(item.key))?.key || "details";

  if (isMobile) {
    return (
      <div className={styles.accountSegmented} role="tablist">
        {items.map((item) => {
          const isActive = activeKey === item.key;
          return (
            <button
              key={item.key}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`${styles.accountSegment} ${
                isActive ? styles.accountSegmentActive : ""
              }`}
              style={isActive ? { color: token.colorPrimary } : undefined}
              onClick={() => onChange(item.key)}
            >
              {item.label}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className={styles.accountTabs}>
      <ConfigProvider
        theme={{
          components: {
            Tabs: {
              horizontalItemPadding: "0",
              horizontalItemGutter: 24,
              colorBorderSecondary: "transparent",
              titleFontSize: 14,
            },
          },
        }}
      >
        <Tabs
          activeKey={activeKey}
          onChange={onChange}
          items={items.map((item) => ({
            key: item.key,
            label: (
              <span
                style={{
                  color:
                    activeKey === item.key
                      ? token.colorPrimary
                      : token.colorText,
                  whiteSpace: "nowrap",
                }}
              >
                {item.label}
              </span>
            ),
          }))}
        />
      </ConfigProvider>
    </div>
  );
};

export default AccountTabs;
